module.exports = __webpack_public_path__ + "img/24.caa676b8.png";